// extracted by mini-css-extract-plugin
export default {"accountPrefContainer":"AccountPrefSection_accountPrefContainer__XNAWB","accountCard":"AccountPrefSection_accountCard__nM8-7"};